/**
 * @generated SignedSource<<52024cf44fc1cc810eb4bb2e450fbf0b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type suggestions_periscope_WorkSuggestionsCompassSuggestionsSwitcher_node$data = {
  readonly __typename: "WorkSuggestionsCompassAnnouncementTask";
  readonly " $fragmentSpreads": FragmentRefs<"announcement_periscope_CompassAnnouncementTask">;
  readonly " $fragmentType": "suggestions_periscope_WorkSuggestionsCompassSuggestionsSwitcher_node";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "suggestions_periscope_WorkSuggestionsCompassSuggestionsSwitcher_node";
};
export type suggestions_periscope_WorkSuggestionsCompassSuggestionsSwitcher_node$key = {
  readonly " $data"?: suggestions_periscope_WorkSuggestionsCompassSuggestionsSwitcher_node$data;
  readonly " $fragmentSpreads": FragmentRefs<"suggestions_periscope_WorkSuggestionsCompassSuggestionsSwitcher_node">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "suggestions_periscope_WorkSuggestionsCompassSuggestionsSwitcher_node",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "announcement_periscope_CompassAnnouncementTask"
        }
      ],
      "type": "WorkSuggestionsCompassAnnouncementTask"
    }
  ],
  "type": "WorkSuggestionsCompassTask",
  "abstractKey": "__isWorkSuggestionsCompassTask"
};

(node as any).hash = "a3b69363c3494c87a675a1efcd9198e2";

export default node;
